import React, { Component } from "react";
import { Row, Col, Card, CardBody, FormGroup, Button, CardTitle, CardSubtitle, Label, Input ,Container, UncontrolledTooltip, Table} from "reactstrap";
import { Link } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";
import PostApiCall from '../../Api'
import GetApiCall from '../../GETAPI'
import Notiflix from "notiflix";
import moment from 'moment'


//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb'


//i18n
import { withNamespaces } from 'react-i18next';

class AddUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            installment:'',
            accountNo:'',
            weight:'',
            Email:'',
            Name:'',
            Mobile:'',
            ConfirmPassword:'',
            Password:'',
            UserData: [
                { value: "Admin", label: "Admin" },
                { value: "Employee", label: "Employee" },
                { value: "Customer", label: "Customer" }
              ],
              User:'',
              DecimalRegex : /^(\d*\.?\d{0,2}|\.\d{0,9})$/,
              NumRegex: /^[0-9]*$/,
              Landmark:'',
              AlphaNumericRegex : /^[a-zA-Z0-9]*$/,
              EmailRegex :  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
              UrlRegex : /^(https:\/\/www\.|https:\/\/www\.|https:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/,    
              isNewPasswordVisible : false,
              isConPasswordVisible : false

        };
    }

   
    accountHandler=(e)=>{
        this.setState({
            Name:e.target.value
        })
    }
    
    mailHandler=(e)=>{
        this.setState({
            Email:e.target.value
        })
    }

    Mobilenumber=(e)=>{
        if((this.state.NumRegex.test(e.target.value)) && (e.target.value.length <= 10)){
                         
        this.setState({
            Mobile:e.target.value
        })
    }
    }

    PasswordChange=(e)=>{
        this.setState({
            Password:e.target.value
        })
    }

    Confirm=(e)=>{
        this.setState({
            ConfirmPassword:e.target.value
        })
    }
    UserChange=(e)=>{
        this.setState({
            User:e.target.value
        })
    }
    
    handleSubmit=()=>{
        if(this.state.Name!==''){    
            if(this.state.Email!=''){
                if(this.state.EmailRegex.test(this.state.Email)){
                    if(this.state.Mobile!=''){
                        if(this.state.Mobile.length==10){
                            if(this.state.User!=''){
                                if(this.state.Password!=''){
                                    if(this.state.ConfirmPassword!=''){
                                        if(this.state.ConfirmPassword==this.state.Password){
                                            this.onPost();

                                        }
                                        else{
                                            Notiflix.Notify.Failure('Password does not match');
                                           }

                                    }
                                    else{
                                        Notiflix.Notify.Failure('Please enter confirm Password');
                                       }
                                    
                                }
                                else{
                                    Notiflix.Notify.Failure('Please enter password');
                                   }

                            }
                            else{
                                Notiflix.Notify.Failure('Please select user');
                               }

                        }
                        else{
                            Notiflix.Notify.Failure('Please enter valid mobile number');
                           }

                    }
                    else{
                        Notiflix.Notify.Failure('Please enter mobile');
                       }
            

                }
                else{
                    Notiflix.Notify.Failure('Please enter valid email');
                   }

            } 
            else{
                Notiflix.Notify.Failure('Please enter your email address');
                
              }       
           
        }
        
        else{
            Notiflix.Notify.Failure('Please enter your full name');
                
           
          }
    }


    onPost=()=>{
        var det = localStorage.getItem('loginedUser')
        var detail = JSON.parse(det)

        Notiflix.Loading.Dots('Please wait...');
       
            PostApiCall.postRequest({
                 name :this.state.Name,
                	email :this.state.Email,
                	mobile :this.state.Mobile,
                	usertype :this.state.User,
                	password :this.state.ConfirmPassword,
                updatedon: moment().format('lll'),
                updatedby: detail[0].fld_userid,
            



            }, "Add_New_User").then((result) =>

                result.json().then(obj => {
                    if (result.status == 200 || result.status == 201) {

                        // console.log(obj)
                        Notiflix.Loading.Remove();
                        Notiflix.Notify.Success('User Successfully added.')
                        window.location.reload()

                    } else {
                        Notiflix.Loading.Remove();
                        Notiflix.Notify.Failure('Something went wrong, try again later.')
                    }
                })
            )
        }


    render() {
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>

                        {/* Render Breadcrumb */}
                        <Breadcrumbs title={this.props.t('User Management')} breadcrumbItem={this.props.t('Add User')} />
                    
                        <Card className="overflow-hidden">
                                <div
                                    className="maxXchange-bg-soft-pink"
                                    style={{ background: 'rgb(171, 61, 0)' }}
                                >
                                    <Row>
                                        <Col xs="6">
                                            <div className="maxXchange-text p-3">
                                                <h5 className="maxXchange-text text-white">
                                                  User Management
                          </h5>
                                            </div>
                                        </Col>
                                    </Row>

                                </div>

                                <Card className="overflow-hidden">
                                    <div className="maxXchange-bg-soft-pink" style={{ background: '#dfb65c' }}>
                                        <Row>
                                            <Col xs="3">
                                                <div className="maxXchange-text p-3">
                                                    <h5 className="maxXchange-text">
                                                     Add User
                                </h5>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>

                                    <CardBody>
                                        <AvForm className="needs-validation" >
                                            <Row>
                                                <Col md="4">
                                                    <FormGroup>
                                                        <Label htmlFor="validationCustom01">Name</Label>
                                                        <AvField
                                                          name="Name"
                                                          type="text"
                                                           className="form-control"
                                                           errorMessage="Enter Your Full Name"
                                                          validate={{ required: { value: true } }}
                                                          id="validationCustom01"
                                                          value={this.state.Name}
                                                          onChange={this.accountHandler}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col md="4">
                                                <FormGroup>
                                                    <Label htmlFor="validationCustom01">Email-Id</Label>
                                                    <AvField
                                                      name="mail"
                                                    
                                                      type="email"
                                                      errorMessage="Enter valid Email-Id"
                                                      className="form-control"
                                                      validate={{ required: { value: true } }}
                                                      id="validationCustom02"
                                                      value={this.state.Email}
                                                      onChange={this.mailHandler}
                                                    />
                                                </FormGroup>
                                                </Col>  
                                                <Col md="4">
                                                <FormGroup>
                                                    <Label htmlFor="validationCustom01">Mobile</Label>
                                                    <AvField
                                                      name="Mobile"
                                               
                                                      type="number"
                                                      errorMessage="Enter Any Valid Mobile Number"
                                                      className="form-control"
                                                      validate={{ required: { value: true } }}
                                                      id="validationCustom017"
                                                      value={this.state.Mobile}
                                                      onChange={this.Mobilenumber}
                                                    />
                                                </FormGroup>
                                                </Col>    
                                            </Row>

                                            <Row>
                                            <Col md="4">
                                            <FormGroup>
                                                        <Label htmlFor="validationCustom03">User Type</Label>
                                                        <select class="form-control" 
                                                        value={this.state.User} 
                                                        errorMessage="Select User Type"
                                                        className="form-control"
                                                        validate={{ required: { value: true } }}
                                                        onChange={this.UserChange} id="installmentDiv"> 
                                                        <option value=''>Select User Type</option>
                                                        {this.state.UserData.map(user => (
                           
                                                         <option key={user.value} value={user.value}>
                                                                  {user.label}
                                                         </option>
                                                        ))}
                                                    </select>
                                                    </FormGroup>
                                                </Col>  
                                                
                                                 
                                                <Col md="4">
                                                <FormGroup>
                                                    <Label htmlFor="validationCustom01">Password</Label>
                                                    <AvField
                                                      name="Password"
                                               
                                                      type={this.state.isNewPasswordVisible ? 'text' : "password"}
                                                      errorMessage="Enter Any Valid Password"
                                                      className="form-control"
                                                      validate={{ required: { value: true } }}
                                                      id="validationCustom04"
                                                      value={this.state.Password}
                                                      onChange={this.PasswordChange}
                                                    />
                                                    <span class="login-icon-change-pass2">
                                                            {/* <i class="icon-dual" data-feather="lock"></i>*/}
                                                             <i style={{color : this.state.isNewPasswordVisible ? 'rgb(216, 23, 100)' : ''}} className="fa fa-eye"
                                                             onClick={()=>{
                                                                 this.setState({
                                                                     isNewPasswordVisible : !this.state.isNewPasswordVisible
                                                                 })
                                                             }}

                                                            
                                                             /> 
                                                        </span>
                                                </FormGroup>
                                                </Col>    
                                                <Col md="4">
                                                <FormGroup>
                                                    <Label htmlFor="validationCustom01">Confirm Password</Label>
                                                    <AvField
                                                      name="ConfirmPassword"
                                               
                                                      type={this.state.isConPasswordVisible ? 'text' : "password"} 
                                                      errorMessage="Enter Confirm Password"
                                                      className="form-control"
                                                      validate={{ required: { value: true } }}
                                                      id="validationCustom05"
                                                      value={this.state.ConfirmPassword}
                                                      onChange={this.Confirm}
                                                    />
                                                     <span class="login-icon-change-pass2">
                                                            {/* <i class="icon-dual" data-feather="lock"></i>*/}
                                                             <i style={{color : this.state.isConPasswordVisible ? 'rgb(216, 23, 100)' : ''}} className="fa fa-eye"
                                                             onClick={()=>{
                                                                 this.setState({
                                                                     isConPasswordVisible : !this.state.isConPasswordVisible
                                                                 })
                                                             }}

                                                            
                                                             /> 
                                                        </span>
                                                </FormGroup>
                                                </Col>                                 
                                            </Row>
                                                                                       
                                            <button type="submit" onClick={this.handleSubmit} className="btn"
                                             style={{backgroundColor:'#880105', color:'#e1b761', float:"right", marginRight:'2%'}}>Save User</button>                         
                                        </AvForm>
                                    </CardBody>
                                </Card>
                                </Card>
                    </Container>
                        
                </div>
          
                </React.Fragment>
        );
    }
}

export default withNamespaces()(AddUser);
